/**
 * CARR Biosystems — Client Configuration
 * Single source of truth for client branding, features, and settings.
 */

export const CLIENT_CONFIG = {
  name: "CARR Biosystems",
  shortName: "CARR",
  tagline: "Intelligence Platform",
  sidebarSubtitle: "Client Intelligence Platform",
  
  logo: "/src/assets/carr-logo.png",
  logoAlt: "CARR Biosystems Logo",
  favicon: "/favicon.ico",
  
  features: {
    auth: true,
    dashboard: true,
    accounts: true,
    contacts: true,
    globalSearch: true,
    
    news: true,
    social: true,
    events: true,
    internalIntel: false,
    
    campaigns: true,
    postGenerator: true,
    contentStudio: false,
    
    targetUniverse: true,
    researchLibrary: true,
    knowledgeBase: false,
    databaseMetrics: true,
    teamProfile: true,
    
    briefingSheets: false,
    pipeline: false,
    academicMarket: false,
    discoveryPool: false,
    clinicalTrials: false,
    drugCandidates: false,
    meetingIntelligence: false,
  },
  
  navigation: {
    accounts: "Accounts",
    contacts: "Contacts",
    news: "News Intelligence",
    social: "Team & People Posts",
    events: "Events",
    campaigns: "Campaigns",
    postGenerator: "Post Generator",
    contentStudio: "Content Studio",
    knowledgeBase: "Knowledge Base",
    databaseMetrics: "Database Analytics",
    teamProfile: "Team Profile",
    meetings: "Meetings",
    meetingIntelligence: "Meeting Intelligence",
    internalIntel: "Internal Intel",
    pipeline: "Sales Pipeline",
    targetUniverse: "Target Universe",
    researchLibrary: "Research Library",
  },
};

export const SUPABASE_CONFIG = {
  url: import.meta.env.VITE_SUPABASE_URL || 'https://drzxmokguptvwptuqjcv.supabase.co',
  anonKey: import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRyenhtb2tndXB0dndwdHVxamN2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzE1NTA0NTcsImV4cCI6MjA4NzEyNjQ1N30.j82imh1o82JeWGtfcN7FszSa0LNcImDXski4qOpqiw0',
};

export const ENV_CONFIG = SUPABASE_CONFIG;

export function isFeatureEnabled(feature: keyof typeof CLIENT_CONFIG.features): boolean {
  return CLIENT_CONFIG.features[feature] ?? false;
}

export function getNavigationLabel(key: keyof typeof CLIENT_CONFIG.navigation): string {
  return CLIENT_CONFIG.navigation[key] ?? key;
}

export type ClientConfig = typeof CLIENT_CONFIG;
export type FeatureFlags = typeof CLIENT_CONFIG.features;
export type NavigationLabels = typeof CLIENT_CONFIG.navigation;
